// Display-font page title with optional sage-coloured emphasis segment.
// Per v2 Soft Pastel: emphasis is colour-only, never italic.
//
// Usage:
//   <PageTitle>Reports.</PageTitle>
//   <PageTitle em="Solid.">1:1 with Akowally.</PageTitle>
//   <PageTitle lede="Twelve readings, six weeks.">Quietly clearer.</PageTitle>

import type { ReactNode } from "react";

export function PageTitle({
  children,
  em,
  lede,
}: {
  children: ReactNode;
  em?: string;
  lede?: ReactNode;
}) {
  return (
    <>
      <h1 className="page-title">
        {children}
        {em ? <> <span className="em">{em}</span></> : null}
      </h1>
      {lede ? <p className="lede">{lede}</p> : null}
    </>
  );
}
